import {AvailableChartDTO} from './AvailableChartDTO';

export class AllAvailableChartDTO {
  monthlyInstagramChart: AvailableChartDTO[];
  weeklyInstagramChart: AvailableChartDTO[];
  monthlyTikTokChart: AvailableChartDTO[];
  weeklyTikTokChart: AvailableChartDTO[];
}
